<template>
    <LRLayout>
        <LeftPanel v-loading="loading">
            <el-tree v-if="data.length" ref="tree" :data="data" :props="defaultProps" :default-expanded-keys="defaultExpandedKeys" highlight-current node-key="id" @node-click="handleNodeClick">
                <span slot-scope="{ node, data }">
                    <span>
                        <svg-icon v-if="data.icon" :icon-class="data.icon" style="width: 12px; height: 12px" />
                        <span style="font-size: 12px">{{ node.label }}</span>
                    </span>
                </span>
            </el-tree>
            <div v-else class="empty-tree">暂无数据</div>
        </LeftPanel>
        <RightPanel v-loading="loading">
            <div class="app-container">
                <data-table v-if="showView === 'listpage'" :module-info="moduleInfo" :tb-columns="tbColumns" :toolbar-btns="listpageBtns" :on-list-data-before-load="onListDataBeforeLoad" :on-list-data-loaded="onListDataLoaded" :on-cell-click="onclick" :on-selected-rows-change="selectedRowsChange" :on-delete-successed="onDeleteSuccessed"></data-table>
            </div>
        </RightPanel>
        <Basicform ref="basicform" :title="formTitle" :module-code="moduleInfo.moduleCode" :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :toolbar-btns="busiformBtns" :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited">
            <template #default="slotProps">
                <busi-form ref="busiform" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
            </template>
        </Basicform>
    </LRLayout>
</template>

<script>
export default {
    data: function () {
        return {
            showView: 'listpage',
            loginUser: {},
            moduleInfo: { formTemplate: 'dcontent/busiformurl?vwtype=W&url=/zbgl/zbxmArch/form.html', addNewUrl: 'zbgl/zbxmArch/addNew', insertUrl: 'zbgl/zbxmArch/insert', getByIdUrl: 'zbgl/zbxmArch/getById', updateUrl: 'zbgl/zbxmArch/update', delUrl: 'zbgl/zbxmArch/delete', listDataUrl: 'zbgl/zbxmArch/listdata', winWidth: 1000, winHeight: 600, moduleCode: 'zbxmArch', openViewType: '0', listAdvSearchAllFields: 0, listAdvSearchExpandPanel: 0 },
            tbColumns: [
                { field: 'state', checkbox: true, width: '45px', align: 'center', sortable: false, fixed: 'false' },
                { align: 'center', field: 'index', title: '序号', width: '45px', sortable: false, fixed: 'false', listAdvSearchElement: '', searchable: false, propType: '' },
                { align: 'center', field: 'zbXmbh', title: '招标项目编号', width: '150px', sortable: true, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 0, propType: 'String' },
                { align: 'center', field: 'projectCode', title: '公司统一编号', width: '180px', sortable: true, listAdvSearchElement: '', searchable: false, listAdvSearchIndex: 1, propType: 'String' },
                { align: 'left', field: 'flSubject', title: '招标项目名称', width: '', sortable: true, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 5, propType: 'String' },
                { enabled: true, align: 'center', field: 'isZgs', title: '是否为总公司项目', width: '180px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'Short', elementFormatter: '1：是\r\n0：否\r\n' },
                { align: 'center', field: 'zbWay', title: '招标方式', width: '120px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'select', searchable: true, listAdvSearchIndex: 4, propType: 'Short', elementFormatter: '1：公开招标\r\n2：邀请招标\r\n3：竞争性谈判\r\n4：询价\r\n5：单一来源\r\n6：竞争性磋商\r\n7：框架协议\r\n' },
                { align: 'center', field: 'zbType', title: '招标类型', width: '120px', sortable: true, listAdvSearchElement: '', searchable: false, listAdvSearchIndex: 2, propType: 'Short', elementFormatter: '1：工程\r\n2：货物\r\n3：服务\r\n' },
                { align: 'center', field: 'zbAmount', title: '预算金额（元）', width: '150px', sortable: true, listAdvSearchElement: '', searchable: false, listAdvSearchIndex: 3, propType: 'java.math.BigDecimal' },
                { align: 'center', field: 'totalAmount', title: '项目金额（元）', width: '150px', sortable: true, listAdvSearchElement: '', searchable: false, listAdvSearchIndex: 3, propType: 'java.math.BigDecimal' },
                { align: 'center', field: 'invoicedAmount', title: '已开票金额（元）', width: '160px', sortable: true, listAdvSearchElement: '', searchable: false, listAdvSearchIndex: 3, propType: 'java.math.BigDecimal' },
                { align: 'center', field: 'theAmountPaid', title: '已支付金额（元）', width: '160px', sortable: true, listAdvSearchElement: '', searchable: false, listAdvSearchIndex: 3, propType: 'java.math.BigDecimal' },
                { align: 'center', field: 'amountToBePaid', title: '待支付金额（元）', width: '160px', sortable: true, listAdvSearchElement: '', searchable: false, listAdvSearchIndex: 3, propType: 'java.math.BigDecimal' },

                { enabled: false, align: 'center', field: 'projectUnit', title: '建设单位', width: '200px', sortable: false, fixed: 'false', listTdEdit: 0, listAdvSearchElement: '', searchable: false, propType: 'String' },
                { enabled: false, align: 'center', field: 'fgsName', title: '招标代理单位', width: '200px', sortable: false, fixed: 'false', listTdEdit: 0, listAdvSearchElement: '', searchable: false, propType: 'String' },
                { enabled: false, align: 'left', field: 'flCreateDept', title: '申请部门', width: '100px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'String' },
                { enabled: false, align: 'center', field: 'flCreateDate', title: '申请日期', width: '110px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'java.util.Date', elementFormatter: 'format：yyyy年MM月dd日\r\n' },
                { enabled: false, align: 'center', field: 'flCreator', title: '申请人', width: '85px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'String' },
                { enabled: false, align: 'center', field: 'status', title: '状态', width: '75px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'Short', elementFormatter: '0：草稿\r\n1：处理中\r\n2：结束\r\n8：已归档\r\n9：已注销\r\n' }
            ],
            listStyle: {},
            listpageBtns: [{ id: 'btn_btn2', btnType: 'toolbar', btnName: '导出', btnIcon: 'export.svg', btnPermission: 'export', btnClick: this.toexportWform, btnI18nCode: 'export' }],
            busiformBtns: [],
            formTitle: '招标项目档案',
            defaultProps: {
                children: 'children',
                label: 'nName'
            },
            orgdata: [],
            newdata: [],
            data: [],
            currentData: {},
            rowsSelected: [],
            currentDataid: '0',
            iszgs: '',
            defaultExpandedKeys: [] // 默认展开第一个节点
        }
    },
    computed: {},
    watch: {
        $route: function (a, b) {
            this.setShowView()
        }
    },
    created: function () {
        this.getTreeList()
        //列表页面配置ID
        this.moduleInfo.listpageViewUrl = '/zbgl/zbxmArch/list.html'
        const _this = this
        this.listpageBtns.forEach(function (btn) {
            btn.btnParams = null
            if (typeof btn.btnClick === 'string') {
                let btnClick = btn.btnClick
                if (btn.btnClick.indexOf('(') !== -1) {
                    let btnParams = btnClick.substring(btnClick.indexOf('(') + 1, btnClick.lastIndexOf(')'))
                    if (btnParams !== '') {
                        btnParams = btnParams.replace(/'/g, '').replace(/ /g, '').split(',')
                        btn.btnParams = btnParams
                    }
                    btnClick = btnClick.split('(')[0]
                }
                if (_this[btnClick]) {
                    btn.btnClick = _this[btnClick]
                }
            }
        })
        // 操作列定义
        // this.tbColumns[this.tbColumns.length] = {
        //     field: 'column_operate',
        //     title: '操作',
        //     width: '70px',
        //     align: 'center',
        //     valign: 'middle'
        // }
        let formurl = this.moduleInfo.formTemplate.split('url=')[1]
        formurl = formurl.replace(/\//g, '.')
        formurl = '#/dcontent/vuebusiform/W/' + formurl.substring(1).replace('.html', '.vue')
        formurl += '?sysCode=' + (this.$route.meta.sysCode || '')
        this.$options.components['BusiForm'] = this.$loadComponent(formurl)
    },
    beforeDestroy: function () {},
    mounted: function () {
        this.setShowView()
    },
    methods: {
        selectedRowsChange(row) {
            this.rowsSelected = row
        },
        // 树节点点击
        handleNodeClick(data) {
            console.log('data', data)
            this.iszgs = ''
            this.currentDataid = ''
            if (data.city) {
                this.currentDataid = data.city.split('-')[data.city.split('-').length - 1]
            } else if (data.iszgs) {
                this.iszgs = 1
            } else {
                this.currentDataid = data.id
            }
            this.$bus.emit('refreshListData')
        },
        toexportWform() {
            console.log(this.rowsSelected, '12321')

            if (!this.rowsSelected.length) {
                this.$confirm('<span>您是否确认要导出当前列表的全部数据?<br/>如果仅需导出部分数据，请先选择或通过搜索筛选。<span>', '确认操作', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    dangerouslyUseHTMLString: true,
                    type: 'warning'
                }).then(() => {
                    // listpageViewUrl=znbg.voteResult.list_PHsWFj.vue
                    window.open(`/apigw/zbgl/zbxmArch/exportdata?pageSize=65000&pageNum=1&listpageViewUrl=%2Fzbgl%2FzbxmArch%2Flist.html&searchAndOr=&fileName=${this.$route.meta.tagTitle}&httpPort=${location.port}&urlsearch=`)
                }).catch(() => {
                // do nothing
                })
            } else {
                var ids = this.rowsSelected.map(item => item.id).join(',')
                window.open(`/apigw/zbgl/zbxmArch/exportdata?pageSize=65000&pageNum=1&listpageViewUrl=%2Fzbgl%2FzbxmArch%2Flist.html&searchAndOr=&fileName=${this.$route.meta.tagTitle}&httpPort=${location.port}&urlsearch=id:${ids}`)
            }
        },
        getTreeList() {
            // this.loading = true
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `base/organMgr/findTreeNodeVOListByNodeId`,
                method: 'GET',
                params: {
                    status: 1,
                    type: 'area',
                    openSysCode: 'zdyr_ecyoa'
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.orgdata = res.body.listdata
                    this.getlistdata()
                } else {
                    this.loading = false
                }
            })
        },
        async getlistdata() {
            var params = {
                pageSize: 999,
                pageNum: 1

            }

            const res = await this.$app.listdata('/zbgl/fgsgl/listdata', params)
            if (res.code === 'success') {
                this.newdata = res.body.pageInfo.list
                const combinedArray = this.orgdata.concat(this.newdata)
                console.log(combinedArray, 'combinedArray')
                this.data = [{ nName: '全部', id: '0', children: this.treeDataAdapter(combinedArray) }]

                if (this.data[0].children) {
                    if (this.data[0].children[1].children) {
                        this.defaultExpandedKeys.push(this.data[0].id)
                        this.currentData = this.data[0]
                        this.$nextTick(() => {
                            this.$refs['tree'].setCurrentKey(this.currentData.id)
                        })
                    }
                }
                this.$forceUpdate()
            }
        },
        treeDataAdapter(allTreeData) {
            const _this = this
            let treeData = JSON.parse(JSON.stringify(allTreeData))

            for (let i = 0; i < treeData.length; i++) {
                const node = treeData[i]

                node.checked = false
                if (node.type) node.type = node.type.replace(/\s*/g, '')

                // 选择机构目录、主机构
                node.pId = node.pId || node.parentID || node.parentId || node.treeId || -1
                node.nodeKeyId = node.id + node.pId
                node.name = node.nName || node.name

                node.canSelect = true

                if (node.orgFullId && !node.orgLevel && !node.olevel) {
                    node.orgLevel = node.orgFullId.split('-').length
                }
            }
            const nodesDict = {}

            const idSet = new Set(
                this.newdata
                    .map((item) => item.city.split('-'))
                    .flat()
                    .map(Number)
            )
            const filteredTreeData = treeData.filter((item) => idSet.has(Number(item.id)))
            console.log(this.newdata, treeData, idSet, 'filteredTreeData')
            const combinedArray = filteredTreeData.concat(this.newdata)
            combinedArray.forEach((item) => {
                if (item.province) {
                    item.parentID = item.city.split('-')[item.city.split('-').length - 1]
                    item.pId = item.city.split('-')[item.city.split('-').length - 1]
                    item.nName = item.name
                    nodesDict[item.id] = item
                    const parent = nodesDict[item.parentID]
                    if (parent) {
                        if (!parent.children) {
                            parent.children = []
                        }
                        parent.children.push(item)
                    }
                } else {
                    nodesDict[item.id] = item
                    const parent = nodesDict[item.parentID]
                    if (parent) {
                        if (!parent.children) {
                            parent.children = []
                        }
                        parent.children.push(item)
                    }
                }
            })
            const zgs = {
                pId: -1,
                parentID: null,
                nName: '总公司',
                canSelect: true,
                checked: false,
                iszgs: 1
            }
            let tree = combinedArray.filter((node) => node.nLevel === 1)
            tree.unshift(zgs)
            console.log(tree, 'tree')

            // treeData格式必须遵循ztreeview treeNode规范
            return tree
        },
        onclick(row) {
            console.log(row, 'row')
            window.open('#/zbtzView?wfEngineUrl=zbgl/zbxmArch&busiDataId=' + row.id + '&logoTitle=' + encodeURIComponent('招标管理/' + row.flSubject))
        },
        setShowView: function () {
            if (this.$route.fullPath.indexOf('itemurl=') !== -1) {
                this.showView = 'mainform'
            } else {
                this.showView = 'listpage'
            }
        },
        /**
         * 加载数据准备，qparams为查询参数对象，不需要返回值
         */
        onListDataBeforeLoad: function ($scope, qparams) {
            this.loginUser = $scope.loginUser
            if (this.iszgs == 1) {
                qparams.urlsearch = 'isZgs:1'
            } else if (this.iszgs == '' && this.currentDataid == '0') {
                qparams.urlsearch = ''
            } else {
                qparams.urlsearch = `city like ${this.currentDataid}`
            }
            console.log('zbxmArch listdata before load..')
        },
        /**
         * 加载数据完成，pageInfo为包含查询结果的分页信息对象，不需要返回值
         */
        onListDataLoaded: function ($scope, pageInfo) {
            console.log('zbxmArch listdata loaded')
        },
        /**
         * 数据删除成功，ids为已删除成功的fgsgl对象ID数组，即将刷新列表，不需要返回值
         */
        onDeleteSuccessed: function ($scope, ids) {
            console.log('zbxmArch delete successed')
        },
        /**
         * 表单打开检查，vo为已加载fgsgl对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
         */
        onBasicFormBeforeOpen: function ($scope, vo, defer) {
            if (process.env.NODE_ENV === 'development') console.log('zbxmArch form before open')
            defer.resolve(true)
        },
        /**
         * 表单打开完成，vo为已加载的fgsgl对象，前端页面dom对象已完成初始化、已经呈现，不需要返回值
         */
        onBasicFormOpened: function ($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('zbxmArch form opened')
        },
        /**
         * 表单提交事件，可执行业务数据高级校验，vo为待提交的fgsgl对象，校验成功：defer.resolve(true)，校验失败：defer.reject(reason)
         */
        onBasicFormBeforeSubmit: function ($scope, vo, defer) {
            /*this.$confirm('您是否确认提交保存?', '确认操作', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              })
                  .then(() => {
                      defer.resolve(true)
                  })
                  .catch(err => {
                      defer.reject(err)
                  })*/

            if (process.env.NODE_ENV === 'development') console.log('zbxmArch form submit validation success')
            defer.resolve(true)
        },
        /**
         * 表单提交完成，vo为已保存成功的fgsgl对象，窗口即将关闭，不需要返回值
         */
        onBasicFormSubmited: function ($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('zbxmArch form submited')
        }
    }
}
</script>

<style scoped lang="scss">
.panel-right {
    position: relative;
    height: calc(100vh - 50px - 50px - 60px - 22px - 20px);
    .el-button-group {
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 99;
    }
}
/deep/ .panel-left .el-tree-node__content {
    height: 30px;
    line-height: 20px;
    border-bottom: none;
    span {
        span {
            font-size: 14px !important;
        }
    }
}
.input-with-select {
    width: 400px;
}
/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: var(--bgColor) !important;
    color: var(--textColor) !important;
}
.el-tree {
    /* 设置滚动条thumb（滑块）的颜色 */
    &::-webkit-scrollbar-thumb {
        background-color: #d2d4da;
        border-radius: 6px;
    }

    /* 增加滚动条的宽度，高度 */
    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    /* 设置滚动条hover时thumb的颜色 */
    &::-webkit-scrollbar-thumb:hover {
        background-color: #d2d4da;
        cursor: pointer;
    }
}
.empty-tree {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #909399;
    font-size: 14px;
}

.right-main {
    display: flex;
    margin-right: 11px;
    margin-left: 10px;
    font-size: 13px;
    align-items: center;
    position: relative;
    .formTapBtn {
        position: absolute;
        top: 0px;
        display: flex;
        left: 50px;
        font-family: MicrosoftYaHei;
        color: #000000;
        font-size: 14px;
        width: 100%;
        .tapItemBtn {
            position: relative;
            margin-right: 15px;
        }
        .active {
            position: relative;
            color: var(--subjectColor);
            font-weight: bold;
            &::after {
                content: '';
                position: absolute;
                bottom: -10px;
                left: 0px;
                width: 100%;
                height: 2px;
                background: var(--subjectColor);
            }
        }
        .tapItemBtn:hover {
            cursor: pointer;
            color: var(--subjectColor);
        }
    }
    .hytz-main .el-table-toolbar-left {
        width: 70% !important;
    }
    .hytz-main .el-table-toolbar-right {
        width: 30% !important;
    }
}
</style>
